import get from "lodash/get";

export const getSelectedLocale = state => get(state, ["i18n", "locale"], "en");

export default getSelectedLocale;
